import * as Long from "long";
import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { selectRecipeFactorAddition } from "../../selectors/selectRecipeInfo";
import { ProductionTransitionArrow } from "../generic/common/ProductionTransitionArrow";
import { ContextMenuBuffButton } from "./ContextMenuBuffButton";
export var ContextMenuProductStrip = React.memo(function (_a) {
    var building = _a.building, recipe = _a.recipe, onBoostProduction = _a.onBoostProduction, recipeList = _a.recipeList, selectedRecipe = _a.selectedRecipe, getProductDisplay = _a.getProductDisplay, getZeroProductionTimeDisplay = _a.getZeroProductionTimeDisplay, getNoProductText = _a.getNoProductText;
    var contextMenuArrowState = selectedRecipe !== undefined ? "" : " inactive";
    var productDisplay = getNoProductText();
    var productStripExtraClass = "big-product";
    var timeIconDisplay;
    if (recipe != undefined) {
        var multiplier = selectRecipeFactorAddition(recipe);
        productDisplay = getProductDisplay(Long.fromValue(multiplier * 100));
        timeIconDisplay = recipe.recipe.skipProduction && getZeroProductionTimeDisplay();
        productStripExtraClass = "";
    }
    return (React.createElement("div", { className: "context-menu-fixed-product-strip" },
        React.createElement("div", { className: IdStyles.ContextMenuBackground + " context-menu-fixed-product-strip-recipe " + productStripExtraClass },
            recipeList,
            React.createElement("div", { className: "context-menu-fixed-product-strip-arrow " + contextMenuArrowState },
                React.createElement(ProductionTransitionArrow, null)),
            productDisplay,
            timeIconDisplay),
        React.createElement(ContextMenuBuffButton, { building: building, onBoostProduction: onBoostProduction, recipe: recipe })));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/ContextMenuProductStrip.tsx
// module id = 2242
// module chunks = 3